
<!--====== Banar Start here======-->

<!-- <div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

              
                <img src="../../../assets/images/banners/finance-banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100" alt="banners" />

              
                <img src="../../../assets/images/banners/finance-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100" alt="banners" />

             
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title">
                                <span>Finance</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span>Actualize innovations with the right tech partner.</span>
                            </div>
                            <div class="col pt-lg-5 pt-5 mt-lg-3">
                                <a href="contact" class="global_button  text-left col  text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow line" /></div>
                                   GET IN TOUCH
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->



<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <!-- "> md" -->
                <img src="../../../assets/images/banners/finance-banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="manufacturing banner" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/finance-mobile.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="manufacturing mobile" />

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-4 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title">
                                <span>Finance</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3">
                                <span >Actualize innovations with the right tech partner. </span>
                            </div>
                            <div class="col pt-lg-5 pt-3 mt-lg-3">
                                <!-- <a href="contact" class="global_button  text-left col pt-5 text-white white_button">
                                    TALk TO AN EXPERT
                                    <i class="fas fa-arrow-right position-relative mt-1 ml-4 display-6"
                                        style="font-weight: 500"></i>
                                </a> -->
                                <a href="contact" class="global_button  text-left col text-white white_button">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow white" /></div>
                                    GET IN TOUCH
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
</div>

<!--====== Banar end here ======-->

<!--====== f Innovate faster and smarter start  ======-->
<div class="laptop_bg_image">
    <div class="container-fluid pt-5">
        <div class="row">
            <div class=" col-lg-6 col-12">
                <div class="mobile_service_images m-5">
                    <img src="../../../assets/images/finance_images/finance-image.png"
                        class="img img-responsive"  alt="finance amount" />
                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="application_content_service global_section_header pt-5">
                    Innovate faster and smarter with cutting-edge Fintech Fechnology.
                </div>
                <div class="application_service-subcontent global_section_content pt-5">
                    <p>Fintech, or financial technology, translates the monetization potential of data. We offer
                        comprehensive consulting services, financial services software engineering, and key technology
                        acceleration solutions in order to prepare for fintech software development and
                        consumer-oriented services in various industry sectors. </p>
                    <p>Our professionals harness innovation and deliver an end-to-end experience that includes strategy,
                        architecture, customer experience, and service management - all within a new fintech ecosystem -
                        from ideation to POC, deployment, and all-inclusive support. </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--======  Innovate faster and smarter end  ======-->


<!--====== Technology capabilities Start ======-->
<div class="feature-large-images-wrapper pt-5 finance_mainbgimage">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="section-title-wrap text-center section-space--mb_30">
                <h2 class="section-sub-title mb-20 global_section_header pt-5">Technology capabilities</h2>
                <p class="global_sub_title vision-content-section">We provide innovative solutions, engineering support, technology
                    expertise, and real-world
                    industry experience to financial service providers. Our consulting, combined with financial
                    services software development, increases a client's organization's productivity, improves their
                    customers' user experience, and increases product visibility across the trending digital
                    platforms. </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
            <div class="row small-mt__30">
                
                <div class="col-lg-3 col-md-6 mt-30">
                    <div class="box-large-image__two finance_itdesignbgimage">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/Digitalinfrastructure.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="finace digitalinfra" />
                            </div>
                            <div class="box-info ">
                                <h3 class="heading">Digital infrastructure </h3>
                                <div class="box-more-info">
                                    <div class="text">Build a virtual cloud environment tailored for your financial solution that supports full 
                                        functionality while lowering infrastructure  costs and eliminating downtime.
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-6 col-md-6  mt-30">
                    <div  class="box-large-image__two finance_itmanagementbgimage">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/Migration.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="finance_images" />
                            </div>
                            <div class="box-info">
                                <h3 class="heading">Migration of legacy applications </h3>
                                <div class="box-more-info">
                                    <div class="text">Migrate critical components of your on-premise systems to the cloud, structuring massive amounts of
                                         legacy data and the most critical features in secure warehouses.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 mt-30">
                    <div class="box-large-image__two finance_datasecuritybgimage">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/forecating-image.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="forecasting finance" />
                            </div>

                            <div class="box-info">
                                <h3 class="heading">Forecasting and real-time analytics </h3>
                                <div class="box-more-info">
                                    <div class="text">Using AI, Machine Learning, and Big Data technologies, we
                                        visualize critical financial insights from analytics and reporting systems
                                        and assist in making data-driven decisions for credit scoring. 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 mt-30">
                    <div  class="box-large-image__two finance_businessreformbgimage">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/R&D.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="r&d finance" />
                            </div>
                            <div class="box-info">
                                <h3 class="heading">R&D breakthroughs </h3>
                                <div class="box-more-info">
                                    <div class="text">We collaborate with financial service providers to create a
                                        proof-of-concept for their innovative idea and support their production
                                        efforts from concept to market-ready solution. 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 mt-30">
                    <div class="box-large-image__two finance_infrastructurebgimage">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/customer-facing.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="customer facing finance" />
                            </div>
                            <div class="box-info">
                                <h3 class="heading">Customer-facing apps and interfaces </h3>
                                <div class="box-more-info">
                                    <div class="text">Create user flows that engage customers with your product while designing user experiences
                                         for value-focused digital solutions in payments and banking. 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 mt-30">
                    <div class="box-large-image__two finance_firewellbgimage ">
                        <div class="box-large-image__two__box">
                            <div class="box-large-image__midea">
                                <img src="../../../assets/images/finance_images/crm.png"
                                    class="single-gallery__thum bg-item-images bg-img" alt="crm finance" />
                            </div>
                            <div class="box-info">
                                <h3 class="heading">CRM</h3>
                                <div class="box-more-info">
                                    <div class="text">Build a CRM software for finance that enables your organization to handle critical data, 
                                        improves customer engagement through a personalized approach, data integration services, and marketing 
                                        solutions ranging from retail to investment and insurance business lines.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!--====== Technology capabilities End ======-->

<!--====== What we do  Start ======-->
<div class="feature-images-wrapper  section-space--ptb_80">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_30">
                    <h2 class="finance-heading section-sub-title  global_section_header pt-5">What we do </h2>
                    <p class="global_sub_title vision-content-section pt-4">With custom financial services software and fintech software, we
                        assist fintech experts, financial institutions, wealth management, banking, and insurance
                        companies in transforming their offerings to meet the needs of emerging customers, shorten time
                        to market, compete using technology, uncover insightful business information, and improve
                        end-product security. </p>
                </div>
            </div>
        </div>
        <div class="feature-images__four">
            <div class=" row">

                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/0nline-payment.png"
                                    alt="payment portal">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Payment portal</div>
                                <div class="text global_section_content">Our focus is on a flawless user experience, security, and fraud
                                    protection as we pioneer in online and in-app payments. </div>
                            </div>
                        </div>
                    </a>
                </div>


                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/mobile-icon.png"
                                    alt="mobile portal">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Mobile banking </div>
                                <div class="text global_section_content">We collaborate with both online and on-premise to streamline financial
                                    operations and digitise customer onboarding processes. 
                                </div>
                            </div>
                        </div>
                    </a>
                </div>


                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/icon.png"
                                    alt="finace portal">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Easy integration </div>
                                <div class="text global_section_content">We develop custom APIs to integrate clients’ solutions with widely
                                    accepted third-party payment services. </div>
                            </div>
                        </div>
                    </a>
                </div>


                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/rsik-management.png"
                                    alt="management risk">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Robotic process automation </div>
                                <div class="text global_section_content">We provide automated communication solutions for the client's users as
                                    well as process automation within the client's company. 
                                </div>
                            </div>
                        </div>
                    </a>
                </div>


                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/reporting.png"
                                    alt="reporting portal">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Reporting and analytics </div>
                                <div class="text global_section_content">With visualisation dashboards and forecasting tools, we help financial
                                    service providers reach decisions much more quickly. </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                    <a (click)="scrollToSection('main-wrapper')" class="ht-box-images style-04">
                        <div class="image-box-wrap">
                            <div class="box-image">
                                <img class="img-fulid"
                                    src="../../../assets/images/finance_images/robotics.png"
                                    alt="robotics portal">
                            </div>
                            <div class="content">
                                <div class="what-heading sixthheading text-dark">Risk management </div>
                                <div class="text global_section_content">By utilising technology to handle financial and regulatory compliance
                                    risks, we enhance business. 
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
</div>
<!--====== What we do  End ======-->


<!--======= Casestudy section End =======-->
<div class="casestudy-layoutsection pt-lg-5">
    <div class=" container-fluid p-0">
        <div class="row">
            <div class="casestudy-mainsection col-12 offset-sm-2 col-sm-8">
                <div class="casestudy_headder global_section_header my-3 mt-lg-5">Client Success Stories</div>
                <div class="insight-subtitle global_sub_title casestudy-subtitle text-center my-3 my-lg-5">

                    Learn how we’re helping our clients take the big move with technology and the difference they make
                    across the globe.
                </div>
            </div>
        </div>

        <!------------------Carousel section starts------>
        <div id="main-wrapper">
            <div class="site-wrapper-reveal">
                <div class="flexible-image-slider-wrapper">
                    <div class="container-fluid p-0">
                        <div class="row m-0">
                            <div class="col-lg-12 p-0">
                                <div class="flexible-image-slider-wrap">
                                    <swiper-container  id="homeCaseStudySwiper" class=" single-flexible__container"  slides-per-view="1"  navigation="true" loop="true">

                                            <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/caseStudyStory.png"
                                                        alt="casestudy button" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-down">
                                                        <div class="row mx-0 h-75 supercharge">
                                                            <div class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100 "
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd); height: 100% !important;">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Supercharge with Cloud and Automation</p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            FUTEK, a leading sensor technology giant
                                                                            takes the leap to cloud for a major IT
                                                                            transformation and innovation.
                                                                        </p>
                                                                        <a href="/futek-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <!-- Single flexible slider End -->
                                                </swiper-slide>
                                                <swiper-slide>
                                                <div class="single-flexible-slider">

                                                    <img class="d-block img img-responsive w-100" alt="homepage"
                                                        src="../../../assets/images/homepage/casestudy-ouropinions-image.png"
                                                        alt="our opinions" />

                                                    <div class="overlay-text_case-studies h-100 w-100"
                                                        data-aos="fade-up">
                                                        <div class="row mx-0 h-75  supercharge ">
                                                            <div
                                                                class="col-12 offset-md-1 col-md-8 col-lg-4 px-0 h-100">
                                                                <div class="casestudy-bacground d-flex h-100"
                                                                    style="background-image: linear-gradient(to right, #ac3eff, #9131de, #a53af6, #2f9edd);">


                                                                    <div class=" px-md-4 m-auto text-center">
                                                                        <p class="text-white caseStudyTitle">
                                                                            Helping exchange social perspectives in a
                                                                            seamless way </p>
                                                                        <p
                                                                            class="text-white global_section_content  casestudy-content-section">
                                                                            Learn how we built a futuristic application
                                                                            and incorporated future cloud advances into
                                                                            our client’s IT infrastructure.
                                                                        </p>
                                                                        <a href="/ouropinion-casestudy"
                                                                            class="global_button  text-left col  text-white white_button">
                                                                            <div class="dub-arrow"><img
                                                                                    src="../../../assets/images/button/arrowWhite.png"
                                                                                    alt="arrow button" /></div>
                                                                            READ CASE STUDY
                                                                        </a>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                                <!-- Single flexible slider End -->
                                            </swiper-slide>

                                     
                                    </swiper-container >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!------------------Carousel section Ends------>
            <div class="industry-button text-center py-3 py-md-5">
                <!-- <a href="case-studies" class="global_button">VIEW ALL<i class="fas fa-arrow-right"></i></a> -->
                <a href="/case-studies" class="global_button d-none d-lg-inline-block text-left col ">
                <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow black" /></div>
                      VIEW ALL
                </a>
            </div>
        </div>
    </div>
</div>
<!--======= Casestudy section Ends =======-->


<div class="layouts-section-wrap">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 offset-sm-2 col-sm-8">
                <div class="pt-md-5" data-aos="fade-up">
                    <div class="insight-title global_section_header">
                        Insights
                        <!-- <a href=""></a> -->
                    </div>
                    <div class="insight-subtitle global_sub_title vision-content-section mt-3">
                        <span>
                            Explore insights and inspiration to unlock innovation, build trust, and engineer advantage
                            for your digital journey.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">

        <div class="-row d-lg-none pt-lg-4">
            <div class="px-4 -col-lg-12">
                <div class="flexible-image-slider-wrap">

                    <swiper-container 
                    class="single-flexible__container " 
                    slides-per-view="1" 
                    autoplay="true" 
                    loop="true" 
                    navigation="true" 
                    pagination="true">
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider1.png" class="img img-responsive w-100 h-100" alt="firstslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>The Future of Marketing Personalization: AI-Powered Journeys</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                            <div>Across the entire customer journey, AI is assisting marketers in providing more helpful, enjoyable experiences for shoppers and improving performance. Find how retail stores can capitalize on this technology trend.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="personalize-and-machine-learning" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="insight arrow" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider2.png" class="img img-responsive w-100 h-100" alt="secondslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Embracing the next era of Digital: From Survival, Thriving to Reinvigorating</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Learn how businesses have progressed into the digital post-pandemic era and how far they can go to adapt to the changing customer mindset.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="/postpandamic" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="casestudy button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                    <swiper-slide>
                      <div class="single-flexible-slider">
                        <img src="../../../assets/images/homepage/insights/slider3.png" class="img img-responsive w-100 h-100" alt="thirdslider" />
                        <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                          <div class="insight-content global_section_header px-0">
                            <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                          </div>
                          <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                            <div>Increase software adoption and knowledge retention while making a positive impact on the working lives of your employees.</div>
                          </div>
                          <div class="insight-button text-center py-3 py-md-5">
                            <a href="migrate-cloud" class="global_button">
                              <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrow button" /></div>READ ALL INSIGHTS
                            </a>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                  
                  </swiper-container>
                  
                </div>
            </div>
        </div>
      
        <div class="" >
            <app-insightsslider></app-insightsslider>
          </div>

    </div>
</div>

